<template>
  <div class="iv-icontree-wrapper">
    <!-- <div>
      <Select
        v-if="showSelect"
        :class="showSpread ? 'iv-fullwidth' : ''"
        class="iv-filterable-select"
        @on-change="onSearchChange"
        @on-query-change="onQueryChange"
        @on-enter="onEnter"
        v-model="inSelectValue"
        transfer
        filterable>
        <Option v-for="(opt, index) in selectOptionList"
                :value="opt.value"
                :key="index">
          <span class="iv-fs-12">{{opt.label}}</span>
        </Option>
      </Select>
      <IconFont
        v-if="showSpread"
        @click="changeTreeWidth"
        class="iv-icon-spread iv-fs-18 iv-pointer iv-hover-color"
        :type="treeCollapse ? 'outdent' : 'indent'"></IconFont>
    </div> -->
    <Col class="iv-search">
      <div>
        <Select
          class="iv-filterable-select iv-fullwidth"
          filterable
          remote
          clearable
          placeholder="请输入搜索内容"
          @on-clear="onSelectClear"
          @on-change="onSearchSelected"
          :remote-method="searchTreeList">
          <Option v-for="(option, index) in treeResultList" :value="option.id" :key="index">{{option.title}}</Option>
        </Select>
      </div>
    </Col>
    <div class="iv-tree-box">
      <Tree
        ref="Tree"
        :checkStrictly="checkStrictly"
        @on-select-change="onNativeSelectChange"
        :data="inData"></Tree>
    </div>
  </div>
</template>
<script>
import render from './render'
import IconFont from '@/components/iconfont'
import {findComponentUpward} from '@/utils'
import collapseTreeMixin from '@/mixins/collapse-tree'
export default {
  mixins: [collapseTreeMixin],
  props: {
    data: {
      type: Array,
      default () {
        return []
      }
    },
    getTitle: {
      type: Function,
      default (title) {
        return title
      }
    },
    showType: {
      type: [String, Array],
      default: 'icon'
    },
    iconMap: {
      type: Object,
      default () {
        return {
          'ORG': 'file-company',
          // 'POST': 'deploymentunit',
          'POST': 'file-job',
          'POSITION': 'user'
        }
      }
    },
    iconType: {
      type: String,
      default: 'orgType'
    },
    showSelect: {
      type: Boolean,
      default: true
    },
    showExtend: {
      type: Boolean,
      default: false
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    showSpread: {
      type: Boolean,
      default: true
    },
    showCheckBox: {
      type: [Boolean, Function],
      default: false
    },
    showSingleCheck: {
      type: [Boolean, Function],
      default: false
    },
    reloadTable: {
      type: Boolean,
      default: true
    },
    checkStrictly: {
      type: Boolean,
      default: false
    },
    treeMap: {
      type: Object,
      default () {
        return {
          title: 'title'
        }
      }
    },
    value: {
      type: [Number, String, Array],
      default: ''
    },
    className: {
      type: Function,
      default: function () {
        return ''
      }
    }
  },
  data () {
    return {
      currentTreeSelect: null,
      treeResultList: [].pop(),
      inData: [],
      treeData: [], //存储原始树结构数据
      searchData: [],
      currentSelect: '',
      selectOptionList: [],
      treeMapIndex: 0,
      treeMapValue: '',
      refTreeFlatState: undefined
    }
  },
  created () {
    this.inSelectValue = ''
    this.render = render.call(this)
    this.inData = [this.transferData(this.data[0] || {})]
    this.getTreeMap(this.treeData, '', '')
    this.init()
  },
  mounted () {
    this.findTreeList = findComponentUpward(this, ['InlineTreeList', 'TreeList'])
  },
  watch: {
    data (newVal) {
      this.inData = [this.transferData(newVal[0] || {})]
      this.treeData = [...this.inData]
      this.selectOptionList = []
      this.getTreeMap(this.treeData, '', '')
    }
  },
  components: {
    IconFont
  },
  provide () {
    return {
      getInjectSelectNode: this.getInjectSelectNode
    }
  },
  methods: {
    init () {
      // 搜索树缓存，空间换时间O(1)
      this.searchResultMap = {}
    },
    getInjectSelectNode () {
      return this.currentTreeSelect
    },
    /* 递归查询搜索结果 */
    searchCode (arr, code, parent) {
      arr.forEach((item, key) => {
        item._parent = parent
        item.children && item.children.length && this.searchCode(item.children, code, item)
        if (item.title.indexOf(code) > -1) {
          // 下拉
          this.curID = item.nodeKey
          this.treeResultList.push(item)
          //return
        }
      })
    },
    /* 搜索结果点击事件 */
    onSearchSelected (id) {
      const item = this.treeResultList.find(item => item.id === id)
      let parent = item?._parent
      while (parent) {
        this.$set(parent, 'expand', true)
        parent = parent._parent
      }
      this.$set(item, 'selected', true)
      this.$set(this.currentTreeSelect, 'selected', false)
      // this.$set(item[0], 'selected', false)
      if (item) {
        // 展开节点树
        // if (item.expand === void 0) {
        //   // let obj = this.$refs.treeList.dataTree
        //   item.parentPath.split('.').forEach(path => {
        //     obj = obj[path]
        //   })
        //   obj.expand = true
        // } else {
        //   item.expand = true
        // }
        // 触发更新
        this.onSelectChanges([item])
        // this.$refs.treeList.forceRender()
      }
    },
    /* 搜索框清空事件 */
    onSelectClear () {
      this.treeResultList = []
    },
    /* 搜索事件 */
    searchTreeList (query) {
      if (this.searchResultMap[query]) return (this.treeResultList = this.searchResultMap[query])
      this.treeResultList = []
      this.searchCode(this.inData, query)
      this.searchResultMap[query] = this.treeResultList
    },
    getTreeMap (arr, index, title) {
      let l = arr.length
      for (let i = 0; i < l; i++) {
        let children = arr[i].children
        let modal = {
          name: arr[i][this.treeMap.title],
          label: title + arr[i][this.treeMap.title],
          value: index + i
        }
        arr[i].path = index + i
        this.selectOptionList.push(modal)
        if (children && children.length) {
          let value = ''
          let NTitle = ''
          !this.treeMapIndex ? (value = i + '>') : (value = `${index}${i}>`)
          !this.treeMapIndex ? (NTitle = arr[i][this.treeMap.title] + '>') : (NTitle = `${title}${arr[i][this.treeMap.title]}>`)
          this.treeMapIndex++
          this.getTreeMap(children, value, NTitle)
        }
      }
    },
    getTreeNode (tree, saveList) {
      let parent = tree.parent
      if (parent || parent === 0) {
        let node = {...this.refTreeFlatState[parent].node}
        let nextTree = this.refTreeFlatState[parent]
        if (!saveList) {
          let curNode = {...tree.node}
          curNode.expand = true
          node.children = [curNode]
          saveList = node
        } else {
          let curNode = {...saveList}
          curNode.expand = true
          node.children = [curNode]
          saveList = node
        }
        this.getTreeNode(nextTree, saveList)
      } else {
        if (!saveList) {
          this.inData = [{...this.refTreeFlatState[0].node}]
        } else {
          this.inData = [saveList]
        }
      }
    },
    /*
      * @description 树形菜单点击事件
      */
    // onSelectChange (items) {
    //   this.modalTreeActive = items[0].title
    //   let resolve = () => {
    //     //this.$emit('on-select-change', items, this.params)
    //     this.$methods('TreeListLayout', 'emitSyncSelect', items)
    //     this.dynamicFormUrl && this.getConfig({
    //       [this.treeMap.id]: items[0] ? items[0][this.treeMap.value || 'id'] : ''
    //     })
    //     this.$methods('Table', 'setParams', Object.assign({}, this.params, {
    //       [this.treeMap.id]: items[0] ? items[0][this.treeMap.value || 'id'] : ''
    //     }))
    //     this.$nextTick(() => {
    //       this.$refs.Edit && this.$methods('Edit', 'setNode', items[0])
    //     })
    //     // 缓存当前选中项
    //     this.currentTreeSelect = items[0]
    //   }
    //   this.$emit('on-select-change', items, resolve)
    //   !this.actionAsync && resolve()
    // },
    onSelectChanges (items) {
      let resolve = () => {
        // 缓存当前选中项
        this.currentTreeSelect = items[0]
      }
      this.currentTreeSelect = items[0]
      this.$emit('on-select-change', items, resolve)
    },
    onSelectChange (root, node, data) {
      if (data.disabled) return
      root.forEach(({node}) => (node.selected = node === data))
      this.currentSelect = data
      if (this.reloadTable) {
        let TreeList = this.findTreeList
        TreeList.$methods('Table', 'setParams', Object.assign({
          [TreeList.treeMap.id]: TreeList.dataTree[0] ? TreeList.dataTree[0][TreeList.treeMap.value || 'id'] : ''
        }, TreeList.params))
        this.$nextTick(() => {
          TreeList.$refs.Edit && TreeList.$methods('Edit', 'setNode', data)
        })
      }
      this.$emit('on-select-change', [data], node, root)
    },
    onNativeSelectChange (currentNode, root, data) {
      this.currentTreeSelect = currentNode[0]
      root && this.onSelectChange(root, data, data)
    },
    onIconExtend (e) {
      e.stopPropagation()
    },
    onEnter (vm, options) {
      let resultOption = !vm.query ? this.selectOptionList[0] : this.selectOptionList.find(item => item.label === vm.query)
      Object.assign(options, resultOption)
    },
    onChange (isCheckd, root, node, data) {
      this.$emit('on-check-change', ...arguments)
      if (this.showSingleCheck) {
        if (node.children && node.children.length) return
        this.onSingleCheck(...arguments)
        return
      }
      this.$refs.Tree.handleCheck({
        checked: !data.checked,
        nodeKey: data.nodeKey
      })
    },
    onSingleCheck (isCheckd, root, node, data) {
      root.forEach(({node}) => {
        let isCheck = node === data
        this.$set(node, 'checked', isCheck)
        this.$set(node, 'selected', isCheck)
      })
    },
    getSelectedNodes () {
      return this.$refs.Tree.getSelectedNodes()
    },
    getCheckedNodes () {
      return this.$refs.Tree.getCheckedNodes()
    },
    transferData (data) {
      data.selected = false
      let queue = [data]
      //let value = Array.isArray(this.value) ? this.value : [this.value]
      while (queue.length) {
        let item = queue.shift()
        if (item.children && item.children.length) {
          queue.push(...item.children)
        }
        item.render = this.render
        if (item.id == this.value) {
          item.checked = true
          this.showSingleCheck && (item.selected = true)
        }
      }
      // 根节点默认展开
      data.expand = true
      return data
    },
    onSearchChange (v) {
      const rootPath = '0'
      // 如果是空或者根节点，我们直接返回
      if (v === rootPath && !this.inSelectValue) {
        this.inSelectValue = ''
        this.getTreeNode({})
        return
      }
      !this.refTreeFlatState && (this.refTreeFlatState = [...this.$refs.Tree.flatState])
      let selectTree = this.refTreeFlatState.find(item => item.node.path === v)
      this.getTreeNode(selectTree)
    },
    onQueryChange (val) {
      if (!val) {
        this.inSelectValue = ''
      }
    },
    updateTree (action = 'add', origin, item) {
      let Tree = this.$refs.Tree
      if (action === 'delete') {
        let idx = (origin.children || []).findIndex(child => child.id === item.id)
        origin.splice(idx, 1)
        return
      } else {
        (origin.children || (origin.children = [])).push(Object.assign(item, {
          render: this.render
        }))
      }
      Tree.flatState = Tree.compileFlatState()
      Tree.rebuildTree()
    },
    getTreeRootNode () {
      return this.$refs?.Tree?.$children[0]?.node[0] || []
    },
    rebuildTreeDom (data) {
      let Tree = this.$refs.Tree
      Tree.handleCheck({
        expand: data.expand,
        checked: !data.checked && !data.indeterminate,
        nodeKey: data.nodeKey
      })
      Tree.flatState = Tree.compileFlatState()
      Tree.rebuildTree()
    }
  }
}
</script>
<style lang="scss" scoped>
  @import 'variable/variable.scss';
  .iv-icontree-wrapper {
    position: relative;
    .iv-filterable-select {
      &.iv-fullwidth {
        padding-right: 24px;
      }
    }
    .iv-icon-spread {
      position: absolute;
      right: 0;
      top: 3px;
    }
    /deep/ .iv-icon-wrapper {
      padding: 2px 4px;
    }
    /deep/ .iv-tree-selected  {
      border-radius: 2px;
    }
    /deep/ .iv-icon {
      position: relative;
      top: 2px;
      margin-right: 4px;
    }
    /deep/ .iv-icon-extend {
      position: relative;
      top: 1px;
      left: 4px;
    }
  }
</style>
